import { apiPost } from '../../../adapters/api-client/api';

export type DisputeStatus = 'OPEN' | 'RESOLVED_RELEASED' | 'RESOLVED_REFUNDED';
export type NoShowParty = 'seller' | 'buyer';

export function completeMilestone(enrollmentId: string, sequence: number): Promise<any> {
  return apiPost(`/api/v1/enrollments/${enrollmentId}/milestones/${sequence}/complete`, {});
}

export function openDispute(enrollmentId: string, sequence: number, reason: string): Promise<any> {
  return apiPost(`/api/v1/enrollments/${enrollmentId}/milestones/${sequence}/dispute`, {
    reason,
  });
}

export function resolveDispute(
  enrollmentId: string,
  disputeId: string,
  status: DisputeStatus,
  resolution: string,
): Promise<any> {
  return apiPost(`/api/v1/enrollments/${enrollmentId}/disputes/${disputeId}/resolve`, {
    status,
    resolution,
  });
}

/**
 * Report that the other party did not attend. The scheduled time and the
 * report time are both derived server-side from the booking — the caller only
 * says *who* was absent, never *when* the session was supposed to run.
 */
export function reportNoShow(
  enrollmentId: string,
  sequence: number,
  party: NoShowParty,
): Promise<any> {
  return apiPost(`/api/v1/enrollments/${enrollmentId}/milestones/${sequence}/no-show`, { party });
}

/** The late-cancel penalty is measured by the server against the booking, never a client date. */
export function cancelEnrollment(enrollmentId: string, reason: string): Promise<any> {
  return apiPost(`/api/v1/enrollments/${enrollmentId}/cancel`, { reason });
}

export function processHoldback(enrollmentId: string): Promise<any> {
  return apiPost(`/api/v1/enrollments/${enrollmentId}/process-holdback`, {});
}
